const lcAvailable = typeof localStorage !== "undefined";

const local_storage = {
  set: (key: string, data: unknown) => {
    if (lcAvailable) {
      localStorage.setItem(key, typeof data === "object" ? JSON.stringify(data) : String(data));
    }
  },
  // JSON when it parses, the raw string when it does not, `null` when there is nothing.
  get: (key: string): any => {
    let result: any = false;

    if (lcAvailable) {
      const stored = localStorage.getItem(key);

      try {
        result = JSON.parse(stored as string);
      } catch (e) {
        result = stored;
      }
    }

    return result || null;
  },
  remove: (key: string | string[]) => {
    if (lcAvailable) {
      if (Array.isArray(key)) {
        key.forEach(k => localStorage.removeItem(k));
      } else {
        localStorage.removeItem(key);
      }
    }
  },
};

export default local_storage;
